export default __webpack_public_path__ + "static/media/Campus princess.524d6e25.JPG";